<template>

    <v-flex xs12 sm6 offset-sm3 pt-4>

        <v-img src="//assets.office4u.xyz/common_asset/coming-soon.png"></v-img>

    </v-flex>

</template>

<script>
export default {
    data() {
        return {

        }
    },
}
</script>

<style scoped>

</style>
